export enum StatusHopeEnum {
    PendenteImportacao = 1,
    PendenteImportacaoDescription = 'Pendente de importação',
    PendenteValidacao = 2,
    PendenteValidacaoDescription = 'Pendente de validação',
    AguardandoVideoconferencia = 3,
    AguardandoVideoconferenciaDescription = 'Aguardando videoconferência',
    Aprovado = 4,
    AprovadoDescription = 'Aprovado',
    Cancelado = 5,
    CanceladoDescription = 'Cancelado',
    VideoconferenciaIniciada = 6,
    VideoconferenciaIniciadaDescription = 'Videoconferência iniciada',
    VideoconferenciaConcluida = 7,
    VideoconferenciaConcluidaDescription = 'Videoconferência concluída',
    ConferenciaIniciada = 8,
    ConferenciaIniciadaDescription = 'Conferência iniciada',
    PendenteRecebimento = 9,
    PendenteRecebimentoDescription = 'Pendente de recebimento',
    AguardandoResolucao = 10,
    AguardandoResolucaoDescription = 'Aguardando resolução'
}

export namespace StatusHopeEnum {
    export function values() {
        return Object.keys(StatusHopeEnum)
            .filter((type) => isNaN(<any>type) && type !== 'values' && !type.includes('Description') && !type.includes('Nenhum'))
            .map(item => {
                return { enum: +StatusHopeEnum[item], description: (StatusHopeEnum[item + 'Description']).split(';')[0] };
            });
    }
}
